import { render, staticRenderFns } from "./dotDialog.vue?vue&type=template&id=244b5386"
import script from "./dotDialog.vue?vue&type=script&lang=js"
export * from "./dotDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports